module.exports = __webpack_public_path__ + "img/font-title-icon.1549777a.svg";